// useAuthStore.js
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
// Importa el almacenamiento correcto según tu entorno.
// Si es React Native, usa:
// import AsyncStorage from '@react-native-async-storage/async-storage'; 
// Si es Web/Expo Web, usa:
// const storage = window.localStorage;

// **IMPORTANTE: ELIGE TU MÉTODO DE ALMACENAMIENTO**
// Si estás en React Native, usa esta configuración (descomentar e instalar):
// const storageMiddleware = createJSONStorage(() => AsyncStorage);
// Si estás en Web (donde usabas localStorage), usa esta configuración:
const storageMiddleware = createJSONStorage(() => window.localStorage);


export const useAuthStore = create(
    persist(
        (set, get) => ({
            // Estado Inicial
            token: null,
            user: null,

            // Acciones (Setters)
            setSession: (token, user) => set({ token, user }),
            logout: () => set({ token: null, user: null }),
            
            // Selector derivado (se puede usar directamente con get().token)
            isAuthenticated: () => !!get().token,
        }),
        {
            name: 'auth-storage', // Clave bajo la cual se guarda el estado en el almacenamiento
            storage: storageMiddleware, // El middleware de persistencia elegido
        }
    )
);

// Función de utilidad para obtener el token fuera de los componentes de React (ej: en interceptores de Axios)
export const getAuthToken = () => useAuthStore.getState().token;